import { Link } from "react-router-dom";

const InquiryButton = ({ color }) => (
  <Link className={ color === "orange" ? "button-circle button-orange" : "button-circle button-white"} to="/anfrage">Anfragen</Link>
);
  
export default InquiryButton;
  